import React, { useEffect, useState } from 'react';
import Table from '../common/CollapseTable';
import tableConfig, { data } from './config';
import { Typography } from '@material-ui/core';
import { ADMIN_PAYMENTS } from '../../constants';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '../common/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from '../common/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DatePicker from "react-datepicker";
import { CsvBuilder } from 'filefy';
import "react-datepicker/dist/react-datepicker.css";

import "./Payment.css"
import { BorderColor } from '@material-ui/icons';

const Payments = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  //console.log("props",props)
  // console.log("props login",props.login)
  let session = sessionStorage.getItem('user');
  const [countryid, setCountryid] = useState("");
  const [fromdate, setFromDate] = useState(null);
  const [todate, setToDate] = useState(null);
  const [sellertype, setSellerType] = useState('');
  const [sellername, setSellerName] = useState('');
  const [paymentstatus, setPaymentStatus] = useState('');
  const [paymentsurl, setPaymentsUrl] = useState(`${ADMIN_PAYMENTS}?countryId=${countryid}`);
  const [tableKey, setTableKey] = useState(1);

  useEffect(() => {
    if (session) {
      setCountryid(`${JSON.parse(session).findAdmin.country_id}`)
    }
  }, [session])

  const getFromDate = (event) => {
    let frDate = event.getFullYear() + "-" + (event.getMonth() + 1) + "-" + event.getDate();
    setFromDate(frDate);
  }

  const getToDate = (event) => {
    let toDate = event.getFullYear() + "-" + (event.getMonth() + 1) + "-" + event.getDate();
    setToDate(toDate);
  }
  const handleSellerType = (event) => {
    setSellerType(event.target.value);
  }
  const handlePaymentStatus = (event) => {
    setPaymentStatus(event.target.value);
  }

  const handleChangeSellerName = (event) => {
    setSellerName(event.target.value);
  }

  const setAPIURL = (event) => {
    let apiUrl = `${ADMIN_PAYMENTS}?countryId=${countryid}`
    apiUrl += sellertype ? `&sellerType=${sellertype}` : ""
    apiUrl += sellername ? `&sellerName=${sellername}` : ""
    apiUrl += fromdate ? `&fromDate=${fromdate}` : ""
    apiUrl += todate ? `&toDate=${todate}` : ""
    apiUrl += paymentstatus ? `&status=${paymentstatus}` : ""

    setPaymentsUrl(apiUrl);
    setTableKey(tableKey + 1);
  }
  const reSetValues = () => {
    setSellerType("");
    setSellerName("");
    setPaymentStatus("");
    setFromDate(null);
    setToDate(null);
    setTableKey(tableKey + 1);
    setPaymentsUrl(`${ADMIN_PAYMENTS}?countryId=${countryid}`);
  }

  // if(role === "superadmin"){
  //    setCountryid(`${JSON.parse(session).countryId}`);
  // } 

  return (<div>
    <div style={{ width: '100%' }}>
      <Card>
        <CardContent>
          <div className="row" style={{ marginLeft: '10px' }}>

            <Grid container spacing={1} className={'mt-3 '}>
              <Grid item xs={2}>
                <FormControl className={classes.formControl}>
                  <Select
                    className='newchange'
                    labelId="demo-simple-select-placeholder-label-label"
                    id="demo-simple-select-placeholder-label"
                    name="sellertype"
                    value={sellertype}
                    onChange={(e) => { handleSellerType(e) }}
                    displayEmpty
                    classes={{ select: classes.inputRoot }}
                  >
                    <MenuItem value="">
                      <em>Select Seller Type</em>
                    </MenuItem>
                    <MenuItem value="Chef">Chef</MenuItem>
                    <MenuItem value="Restaurant">Restaurant</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <TextField
                  className="newchange"
                  styles={{
                    margin: "0"
                  }}
                  parentStyles={{
                    margin: 0
                  }}
                  placeholder="Seller Name"
                  // importStyle={true}
                  name="sellername"
                  value={sellername}
                  onChange={(e) => handleChangeSellerName(e)}
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  onChange={(e) => { getFromDate(e) }}
                  value={fromdate}
                  placeholderText="From Date"
                  dateFormat="dd/MM/yyyy"
                  className="form-control newchange"
                  dropdownMode="select"
                  inlineFocusSelectedMonth
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  onChange={(e) => { getToDate(e) }}
                  value={todate}
                  placeholderText="To Date"
                  dateFormat="dd/MM/yyyy"
                  className="form-control newchange"
                  dropdownMode="select"
                  inlineFocusSelectedMonth
                />
              </Grid>
              <Grid item xs={2}>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="demo-simple-select-placeholder-label-label"
                    id="demo-simple-select-placeholder-label"
                    name="paymentstatus"
                    value={paymentstatus}
                    onChange={(e) => { handlePaymentStatus(e) }}
                    displayEmpty
                    classes={{ select: classes.inputRoot }}
                  >
                    <MenuItem value="">
                      <em>Select Status</em>
                    </MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                    <MenuItem value="unpaid">Unpaid</MenuItem>
                    {/* <MenuItem value="failed">Failed</MenuItem> */}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <input type="button" className={classes.button} value="Search" onClick={(e) => { setAPIURL(e) }} />
              </Grid>
              <Grid item xs={1}>
                <input type="button" className={classes.button} value="Reset" onClick={(e) => { reSetValues(e) }} />
              </Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className='payments-table-wrapper'>
      <Table
        noBorder={true}
        key={tableKey}
        tableConfig={config}
        data={data}
        apidata="payments"
        countryid={countryid}
        url={paymentsurl}
      />
    </div>
  </div>)
};

export default Payments;
